/* 
    Import
*/
import axios from "axios";
import { baseUrl } from "../config/app.config";

/**
 * Upload Excel
 * Method : Post
 */
export const UploadExcel = async model => {
  let result = { error: false, data: "" };

  try {
    let response = await axios({
      method: "post",
      url: baseUrl + "/api/Operations/UploadExcel",
      data: model,
      config: {
        headers: { "Content-Type": "multipart/form-data" }
      }
    });
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const GetBranchDetails = async (province, city) => {
  let result = { error: false, data: "" };

  try {
    let response = await axios({
      method: "get",
      url:
        baseUrl +
        "/api/Operations/GetOperationStatus?province=" +
        province +
        "&city=" +
        city
    });
    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const GetProvinceAndCity = async () => {
  let result = { error: false, data: "" };

  try {
    let response = await axios({
      method: "get",
      url: baseUrl + "/api/Operations/GetProvinces"
    });
    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = error.response;
  }
  return result;
};

/**
 * Update brabch details
 * Method : Post
 */
export const UpdateBranchDetails = async model => {
  let result = { error: false, data: "" };

  try {
    let response = await axios({
      method: "post",
      url: baseUrl + "/api/Operations/UpdateStatus",
      data: model
    });
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};
